/**
 * Global 404 page (Phase 3 #10).
 *
 * Fires a `page_not_found` PostHog event on mount with the attempted path
 * + referrer so we can find broken external links and admin typos.
 */

'use client'

import { useEffect } from 'react'
import Link from 'next/link'
import { Home } from 'lucide-react'
import { trackPageNotFound } from '@/lib/posthog-events'

export default function NotFound() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    trackPageNotFound(
      window.location.pathname + window.location.search,
      document.referrer || null,
    )
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
          <Home className="w-10 h-10 text-red-500" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">
          404
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Page not found
        </p>
        <Link
          href="/"
          className="inline-block px-8 py-3 bg-gradient-to-r from-[#01323E] to-[#024556] hover:from-[#024556] hover:to-[#01323E] text-white rounded-full font-semibold shadow-lg transition-all transform hover:scale-105"
        >
          ← Home
        </Link>
      </div>
    </div>
  )
}
